import { generateStripeState } from '../helper'

const options = {
  api: {
    get: ({ id }) => `/api/stripe/invoice/${id}`,
    list: () => `/api/stripe/invoices`,
    delete: ({ id }) => `/api/stripe/invoice/${id}`,
    update: ({ id }) => `/api/stripe/invoice/${id}`,
    create: () => `/api/stripe/invoice`
  },
  state: {
    collectionName: 'invoices'
  },
  getters: {
    getPagination: 'getInvoicePagination',
    getCollection: 'getInvoices'
  },
  actions: {
    get: 'getInvoice',
    list: 'listInvoices',
    delete: 'deleteInvoice',
    update: 'updateInvoice',
    create: 'createInvoice'
  },
  mutationKey: 'INVOICE',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions,
    async payInvoice({ state, commit, dispatch }, data) {
      const { id, source, payment_method } = data
      const path = `/api/stripe/invoice/${id}/pay`

      const payload = { source, payment_method}

      const entity = await this.$api.post(path, payload)
        .then(res => res.data)
        .catch(e => { dispatch('snackError', e) })

      return entity
    },
    async finalizeInvoice({ state, commit, dispatch }, data) {
      const { id } = data
      const path = `/api/stripe/invoice/${id}/finalize`

      const entity = await this.$api.post(path)
        .then(res => res.data)
        .catch(e => { dispatch('snackError', e) })

      return entity
    },
    async voidInvoice({ state, commit, dispatch }, data) {
      const { id } = data
      const path = `/api/stripe/invoice/${id}/void`

      const entity = await this.$api.post(path)
        .then(res => res.data)
        .catch(e => { dispatch('snackError', e) })

      return entity
    },
    async uncollectibleInvoice({ state, commit, dispatch }, data) {
      const { id } = data
      const path = `/api/stripe/invoice/${id}/uncollectible`

      const entity = await this.$api.post(path)
        .then(res => res.data)
        .catch(e => { dispatch('snackError', e) })

      return entity
    },
    async paidInvoice({ state, commit, dispatch }, data) {
      const { id } = data
      const path = `/api/stripe/invoice/${id}/paid`

      const entity = await this.$api.post(path)
        .then(res => res.data)
        .catch(e => { dispatch('snackError', e) })

      return entity
    },
    async sendInvoice({ state, commit, dispatch }, data) {
      const { id } = data
      const path = `/api/stripe/invoice/${id}/send`

      const entity = await this.$api.post(path)
        .then(res => res.data)
        .catch(e => { dispatch('snackError', e) })

      return entity
    }
  },
  mutations:{
    ...stripeMutations
  }
}
